var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"pa-1",attrs:{"xs12":"","sm6":"","md6":"","lg4":"","fill-height":""}},[_c('stat-card',{attrs:{"loading":_vm.loading},model:{value:(_vm.total),callback:function ($$v) {_vm.total=$$v},expression:"total"}},[_vm._v(_vm._s(_vm.$t('ทั้งหมด')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-095e9408","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/dashboard/customize/uu/UuBroadcastStat.vue
// module id = null
// module chunks = 